import classes from "./mobile-nav.module.scss";
import classNames from "classnames";

import ExpandableContainer from "@/components-library/layout/expandable-container";
import ExpandableGroup from "@/components-library/layout/expandable-group";
import Header from "./header";
import Content from "./content";
function MobileNav({ clickMobile, onClickMobile, onClick, onClickLogo }) {
  return (
    <>
      <ExpandableContainer
        header={
          <Header
            clickMobile={clickMobile}
            onClickLogo={onClickLogo}
            onClickMobile={onClickMobile}
          />
        }
        isOpen={clickMobile}
        className={classNames(classes.mobileNavContainer, {
          [classes.open]: clickMobile,
        })}
      >
        <ExpandableGroup singleOpen={clickMobile}>
          <Content onClick={onClick} />
        </ExpandableGroup>
      </ExpandableContainer>
    </>
  );
}

export default MobileNav;
